import LoaderComponent from '@/components/LoaderComponent';
import { getFileType } from '@/utils/Util';

const Preview = ({ docUrl, docName, selectedProductId, isLoading }) => {
	const url = docUrl?.trim() ?? '';

	let inner;
	if (!url) {
		inner = (
			<div className="no-preview-file d-flex align-items-center justify-content-center">
				<div>
					<p className="semibold-14 gray_dark_02 pt-4">
						{selectedProductId != null
							? 'No document URL for this product'
							: 'No product has been selected'}
					</p>
				</div>
			</div>
		);
	} else {
		const typeFromUrl = getFileType(url);
		const name = docName || '';
		const fileType = typeFromUrl === 'NO_FILE' && name ? getFileType(name) : typeFromUrl;

		if (fileType === 'PDF') {
			inner = (
				<div className="embed-responsive embed-responsive-16by9">
					<iframe
						className="embed-responsive-item"
						src={url}
						title="Techpack document"
						allowFullScreen
					/>
				</div>
			);
		} else if (fileType === 'IMAGE') {
			inner = (
				<div className="techpack-doc-image-preview embed-responsive embed-responsive-16by9">
					<img className="embed-responsive-item" src={url} alt={name || 'Techpack'} />
				</div>
			);
		} else {
			inner = (
				<div className="no-preview-file">
					<div>
						<p className="semibold-14 gray_dark_02">No preview available </p>
						<button
							type="button"
							className="button outline size32 mt-3"
							onClick={() => window.open(url, '_blank')}
						>
							<img
								src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
								alt="download"
								className="mr-1"
							/>
							Download file
						</button>
					</div>
				</div>
			);
		}
	}

	return (
		<div className="teckpack-preview-section ml-4">
			<LoaderComponent loading={isLoading}>{inner}</LoaderComponent>
		</div>
	);
};

export default Preview;
